export const MaskPattern = {
  NumberOnly: 'numberOnly',
  AlphaMarkNumberOnly: 'alphaMarkNumberOnly',
  HalfWidthOnly: 'halfWidthOnly',
  HalfWidthWithKanaOnly: 'halfWidthWithKanaOnly'
}

export const MarkMaxlength: string = '18'

export const NdcMask: string = MaskPattern.HalfWidthOnly

export const NdcMaxlength: string = '36'

export const BookMaxlength: string = '60'

export const SubMaxlength: string = '42'

export const VolumeMask: string = '#'.repeat(4)

export const VolumeNumberMask: string = '#'.repeat(4)

export const VolumeTotalMask: string = '#'.repeat(6)

export const IsbnMask: string = 'X'.repeat(13)

export const MarcNoMask: string = 'X'.repeat(8)
